<template>
  <div class="layout" style="height:100%;overflow-y:auto">
    <Tree :data="rootData" @on-toggle-expand="onToggleExpand" @on-select-change="onExchangChange" :render='renderContent' ></Tree>
  </div>
</template>
<script>
import api from "@/api/aipause";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  props: ["masd"],
  data() {
    return {
      //树结构
      rootData: [],
      asf: "",
      asde: true,
      menuIdList: [],
      listRoleMenu: [],
      // msg: "传递给父组件的值",
      chosedata: [],
      path: this.masd,
      num: 0,
      t: null,
      path: null,
      path1: null,
      selectedNodeId:0,
      overNodeId:0
    };
  },

  methods: {
    ...mapActions(["handleLogOut"]),
    onToggleExpand(item) {
      let local =this;
      item.children.splice(0, 1);
      let url = this.getUrl(item.resType);
      let id = item.id;
      api("GET", url, {}, id).then(res => {
        let data = res.data;
        if (data.code === 0) {
          item.children = [];
          let itemTitle = this.getTitle(item.resType, data);
          for (let i = 0; i < itemTitle.length; i++) {
            let itenName = this.getName(item.resType, itemTitle[i]);
            if (item.resType == 21) {
              let itemTitle = this.getTitle(item.resType, data);
              if (itemTitle[i].directoryType == 1) {
                item.children.push({
                  color: local.getObjectUpdateColor(itemTitle[i].updated),
                  title: itenName,
                  id: itemTitle[i].id,
                  resType: itemTitle[i].resType,
                  expand: false,
                  res: 12,
                  directoryType: itemTitle[i].directoryType,
                  children: itemTitle[i].hasSubItems == true ? [{}] : [],
                  clientId: itemTitle[i].clientId,
                  deviceType: itemTitle[i].deviceType

                });
              }else{
                item.children.push({
                  color: local.getObjectUpdateColor(itemTitle[i].updated),
                  title: itenName,
                  id: itemTitle[i].id,
                  resType: itemTitle[i].resType,
                  expand: false,
                  children: itemTitle[i].hasSubItems == true ? [{}] : [],
                  clientId: itemTitle[i].clientId,
                  deviceType: itemTitle[i].deviceType
                });
              }
            } else {
              item.children.push({
                color: local.getObjectUpdateColor(itemTitle[i].updated),
                title: itenName,
                id: itemTitle[i].id,
                resType: itemTitle[i].resType,
                expand: false,
                children: itemTitle[i].hasSubItems == true ? [{}] : [],
                clientId: itemTitle[i].clientId
              });
            }
          }
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    getUrl(objType) {
      if (0 == objType) {
        return "clientSubList";
      } else if (21 == objType) {
        return "projectSubList";
      } else if (22 == objType) {
        return "directorySubList";
      } else if (23 == objType) {
        return "channelSubList";
      }
    },
    getTitle(objType, obj) {
      if (0 == objType) {
        return obj.project;
      } else if (21 == objType) {
        return obj.directory;
      } else if (22 == objType) {
        return obj.point == undefined ? obj.subDir : obj.point;
      } else if (24 == objType) {
        return obj.subDir;
      }
    },
    getName(objType, obj) {
      if (0 == objType) {
        return obj.prjName;
      } else if (21 == objType) {
        localStorage.setItem("deviceType", obj.deviceType);
        return obj.directoryName;
      } else if (22 == objType) {
        return obj.pntName == undefined ? obj.directoryName : obj.pntName;
      } else if (23 == objType) {
        return obj.directoryName;
      }
    },
    onExchangChange( itemClicked) {
        this.$emit("chosecha", {
          title: itemClicked
        });
      //非通道属性页面
      if (this.$route.name !== "channel_properties") {
        //工程页面
        if ( itemClicked.resType == 21 &&
          this.$route.name !== "connect_cha" &&
          this.$route.name !== "home" &&
          this.$route.name !== "device_instruction"
        ) {
          //柔性测斜仪页面
          if (
            this.$route.name == "3D_diagram" ||
            this.$route.name == "data_browse_point" ||
            this.$route.name == "2D_figure" ||
            this.$route.name == "allData" ||
            this.$route.name == "sensor_Figure" ||
            this.$route.name == "relative_Displacement" ||
            this.$route.name == "management" ||
            this.$route.name == "3D_Stereogram"
          ) {
            this.$router.push({
              name: "data_browse_point",
              query: {
                prjid: itemClicked.id
              }
            });
            // return;
          } else {
            //非柔性测斜仪页面
            if (this.$route.name == "data_browse_realtime") {
              this.$router.push({
                name: "data_browse_point",
                query: {
                  prjid: itemClicked.id
                }
              });
            } else {
              this.$router.push({
                name: "engineering_attr",
                query: {
                  prjid: itemClicked.id,
                  prjName: itemClicked.title,
                  prjNum: itemClicked.num,
                  clientId: itemClicked.clientId
                }
              });
            }
          }
        }
        //目录页面
        if (
          itemClicked.resType == 22 &&
          this.$route.name !== "connect_cha" &&
          this.$route.name !== "device_instruction"
        ) {
          //目录类型为父目录
          if (
            itemClicked.directoryType == 1 &&
            this.$route.name == "data_browse_point"
          ) {
            if (itemClicked.directoryType == 0) {
              this.$router.push({
                name: "data_browse_realtime"
              });
            } else {
               if( itemClicked.deviceType != undefined && itemClicked.deviceType != 0 ){
                  localStorage.setItem("deviceId", itemClicked.id);
                  this.$router.push({
                    path: `/engineering/3D_diagram/${itemClicked.id}`
                  });
               }
              // return;
            }
          } else {
            //目录类型为测点目录
            if (
              itemClicked.res == 12 &&
              this.$route.name !== "3D_diagram" &&
              this.$route.name !== "2D_figure" &&
              this.$route.name !== "allData" &&
              this.$route.name !== "sensor_Figure" &&
              this.$route.name !== "relative_Displacement" &&
              this.$route.name !== "management" &&
              this.$route.name !== "3D_Stereogram" &&
              this.$route.name == "point_attr"
            ) {
              this.$router.push({
                name: "section",
                // params:{
                //   directory:2
                // },
                query: {
                  directoryid: itemClicked.id,
                  clientId: itemClicked.clientId,
                  directoryType: itemClicked.directoryType,
                  parentId: itemClicked.parentId
                }
              });
            } else {
              if (
                this.$route.name == "3D_diagram" ||
                this.$route.name == "2D_figure" ||
                this.$route.name == "allData" ||
                this.$route.name == "sensor_Figure" ||
                this.$route.name == "relative_Displacement" ||
                this.$route.name == "management" ||
                this.$route.name == "3D_Stereogram"
              ) {
                if( itemClicked.deviceType != undefined && itemClicked.deviceType != 0 ){
                    localStorage.setItem("deviceId", itemClicked.id);
                      this.$router.push({
                        path: `/engineering/3D_diagram/${itemClicked.id}`
                      });
                }               
              } else {
                if (this.$route.name == "data_browse_point") {
                  // this.$router.push({
                  //   name: "data_browse_realtime"
                  // });
                } else {
                  // localStorage.setItem("deviceId", itemClicked.id);
                  this.$router.push({
                    name: "directory_attar",
                    query: {
                      directoryid: itemClicked.id,
                      directoryname: itemClicked.title,
                      directorynum: itemClicked.nodeNum,
                      clientId: itemClicked.clientId,
                      deviceType: itemClicked.deviceType,
                      directoryType: itemClicked.directoryType,
                      parentId: itemClicked.parentId,
                      projectId: itemClicked.projectId,
                      resType: itemClicked.resType
                    }
                  });
                }
              }
            }
          }
        }
        if (
          itemClicked.resType == 23 &&
          this.$route.name !== "connect_cha" &&
          this.$route.name !== "device_instruction"
        ) {
          if (
            itemClicked.res == 13 &&
            this.$route.name !== "section" &&
            this.$route.name !== "point_attr"
          ) {
            if (
              this.$route.name == "data_browse_point" ||
              this.$route.name == "3D_diagram" ||
              this.$route.name == "data_browse_realtime"
            ) {
              this.$router.push({
                name: "data_browse_point",
                query: {
                  prjid: itemClicked.id,
                }
              });
            } else if (
              this.$route.name == "engineering_attr" ||
              this.$route.name == "directory_attar" ||
              this.$route.name == "section" ||
              this.$route.name == "engineering_index"
            ) {
              this.$router.push({
                name: "point_attr",
                query: {
                  pntName: itemClicked.title,
                  id: itemClicked.id,
                  resType: itemClicked.resType,
                  clientId: itemClicked.clientId,
                  directoryId: itemClicked.directoryId,
                  pntNum: itemClicked.pntNum,
                  status: itemClicked.status,
                  pntWarnUp: itemClicked.pntWarnUp,
                  pntWarnDown: itemClicked.pntWarnDown,
                  pntValMax: itemClicked.pntValMax,
                  pntValMin: itemClicked.pntValMin,
                  pointid: itemClicked.pointid,
                  pntChannel: itemClicked.pntChannel
                }
              });
            }
          } else {
            if (
              this.$route.name == "3D_diagram" ||
              this.$route.name == "2D_figure" ||
              this.$route.name == "allData" ||
              this.$route.name == "sensor_Figure" ||
              this.$route.name == "relative_Displacement" ||
              this.$route.name == "management" ||
              this.$route.name == "3D_Stereogram"
            ) {
              this.$router.push({
                name: "data_browse_point",
                query: {
                  prjid: itemClicked.id
                }
              });
            } else {
              if (
                this.$route.name == "data_browse_point" ||
                this.$route.name == "data_browse_realtime"
              ) {
                this.$router.push({
                  name: "data_browse_point",
                  query: {
                    pntId: itemClicked.id,
                    pntName: itemClicked.title
                  }
                });
              } else {
                this.$emit("getData", itemClicked.id);
                this.$router.push({
                  name: "point_attr",
                  query: {
                    pntName: itemClicked.title,
                    id: itemClicked.id,
                    resType: itemClicked.resType,
                    clientId: itemClicked.clientId,
                    directoryId: itemClicked.directoryId,
                    pntNum: itemClicked.pntNum,
                    status: itemClicked.status,
                    pntWarnUp: itemClicked.pntWarnUp,
                    pntWarnDown: itemClicked.pntWarnDown,
                    pntValMax: itemClicked.pntValMax,
                    pntValMin: itemClicked.pntValMin,
                    pointid: itemClicked.pointid,
                    pntChannel: itemClicked.pntChannel
                  }
                });
              }
            }
          }
        }      
      } else {
      //通道属性页面
        if (itemClicked.res == "13" || itemClicked.res == "113") {
          this.$emit("getData", itemClicked.id);
        }
      }
    },
    //定位
    locateItem(item) {
      
      let local = this;
      for (let i = 0; i < this.rootData.length; i++) {
        this.rootData[i].children = [{}];
        this.rootData[i].expand = false;
        if (item[0] == this.rootData[i].id) {
          this.rootData[i].children = [];
          api("GET", "clientLocate", {}, item[1] + "/" + item[2]).then(res => {
            let data = res.data;
            if (data.code === 0) {
              this.rootData[i].expand = true;
              data.tree.selectedNode.children.map((item1)=>{
                this.rootData[i].children.push({
                  color: local.getObjectUpdateColor(item1.nodeValue.updated),
                  title: item1.nodeValue.prjName,
                  id: item1.nodeValue.id,
                  resType: item1.nodeValue.resType,
                  selected: item1.nodeValue.id == item[2] ? true :false,
                  expand: false,
                  children: item1.nodeValue.hasSubItems == true ? [{}] : []
                });
              })
              if(item[1] == 22){
                if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.directoryType == 1){
                  for(let a = 0 ; a < this.rootData[i].children.length ; a++){
                    if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.projectId == this.rootData[i].children[a].id){
                      this.rootData[i].children[a].expand = true;
                      this.rootData[i].children[a].selected = false;
                      this.rootData[i].children[a].children = []
                      data.tree.selectedNode.selectedNode.children.map((item1)=>{
                        this.rootData[i].children[a].children.push({
                          color: local.getObjectUpdateColor(item1.nodeValue.updated),
                          title: item1.nodeValue.directoryName,
                          id: item1.nodeValue.id,
                          resType: item1.nodeValue.resType,
                          deviceType: item1.nodeValue.deviceType,
                          selected: item1.nodeValue.id == item[2] ? true :false,
                          expand: false,
                          children: item1.nodeValue.hasSubItems == true ? [{}] : []
                        });
                      })
                      for(let r = 0 ; r < this.rootData[i].children[a].children.length ; r++){
                        if(data.tree.selectedNode.selectedNode.selectedNode.selectedNode.nodeValue.parentId == this.rootData[i].children[a].children[r].id){
                          this.rootData[i].children[a].children[r].expand = true;
                          this.rootData[i].children[a].children[r].selected = false;
                          this.rootData[i].children[a].children[r].children = []
                          data.tree.selectedNode.selectedNode.selectedNode.children.map((item1)=>{
                            this.rootData[i].children[a].children[r].children.push({
                              color: local.getObjectUpdateColor(item1.nodeValue.updated),
                              title: item1.nodeValue.directoryName,
                              id: item1.nodeValue.id,
                              resType: item1.nodeValue.resType,
                              deviceType: item1.nodeValue.deviceType,
                              selected: item1.nodeValue.id == item[2] ? true :false,
                              expand: false,
                              children: item1.nodeValue.hasSubItems == true ? [{}] : []
                            });
                          })
                        }
                      }
                    }
                  }
                }else{
                  for(let a = 0 ; a < this.rootData[i].children.length ; a++){
                    if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.projectId == this.rootData[i].children[a].id){
                      this.rootData[i].children[a].expand = true;
                      this.rootData[i].children[a].selected = false;
                      this.rootData[i].children[a].children = []
                      if(data.tree.selectedNode.selectedNode.children.length !== 0){
                        data.tree.selectedNode.selectedNode.children.map((item1)=>{
                          this.rootData[i].children[a].children.push({
                            color: local.getObjectUpdateColor(item1.nodeValue.updated),
                            title: item1.nodeValue.directoryName,
                            id: item1.nodeValue.id,
                            resType: item1.nodeValue.resType,
                            deviceType: item1.nodeValue.deviceType,
                            selected: item1.nodeValue.id == item[2] ? true :false,
                            expand: false,
                            children: item1.nodeValue.hasSubItems == true ? [{}] : []
                          });
                        })
                      }
                    }
                  }
                }
              }
              if(item[1] == 23){
                if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.directoryType == 1){
                  for(let a = 0 ; a < this.rootData[i].children.length ; a++){
                    if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.projectId == this.rootData[i].children[a].id){
                      this.rootData[i].children[a].expand = true;
                      this.rootData[i].children[a].selected = false;
                      this.rootData[i].children[a].children = []
                      data.tree.selectedNode.selectedNode.children.map((item1)=>{
                        this.rootData[i].children[a].children.push({
                          color: local.getObjectUpdateColor(item1.nodeValue.updated),
                          title: item1.nodeValue.directoryName,
                          id: item1.nodeValue.id,
                          resType: item1.nodeValue.resType,
                          deviceType: item1.nodeValue.deviceType,
                          selected: item1.nodeValue.id == item[2] ? true :false,
                          expand: false,
                          children: item1.nodeValue.hasSubItems == true ? [{}] : []
                        });
                      })
                      for(let r = 0 ; r < this.rootData[i].children[a].children.length ; r++){
                        if(data.tree.selectedNode.selectedNode.selectedNode.selectedNode.nodeValue.parentId == this.rootData[i].children[a].children[r].id){
                          this.rootData[i].children[a].children[r].expand = true;
                          this.rootData[i].children[a].children[r].selected = false;
                          this.rootData[i].children[a].children[r].children = []
                          data.tree.selectedNode.selectedNode.selectedNode.children.map((item1)=>{
                            this.rootData[i].children[a].children[r].children.push({
                              color: local.getObjectUpdateColor(item1.nodeValue.updated),
                              title: item1.nodeValue.directoryName,
                              id: item1.nodeValue.id,
                              resType: item1.nodeValue.resType,
                              deviceType: item1.nodeValue.deviceType,
                              selected: item1.nodeValue.id == item[2] ? true :false,
                              expand: false,
                              children: item1.nodeValue.hasSubItems == true ? [{}] : []
                            });
                          })
                          for(let t = 0 ; t < this.rootData[i].children[a].children[r].children.length ; t++){
                            if(data.tree.selectedNode.selectedNode.selectedNode.selectedNode.selectedNode.nodeValue.directoryId == this.rootData[i].children[a].children[r].children[t].id){
                              this.rootData[i].children[a].children[r].children[t].expand = true;
                              this.rootData[i].children[a].children[r].children[t].selected = false;
                              this.rootData[i].children[a].children[r].children[t].children = []
                              data.tree.selectedNode.selectedNode.selectedNode.selectedNode.children.map((item1)=>{
                                this.rootData[i].children[a].children[r].children[t].children.push({
                                  color: local.getObjectUpdateColor(item1.nodeValue.updated),
                                  title: item1.nodeValue.pntName,
                                  id: item1.nodeValue.id,
                                  resType: item1.nodeValue.resType,
                                  selected: item1.nodeValue.id == item[2] ? true :false,
                                });
                              })
                            }
                          }
                        }
                      }
                    }
                  }
                }else{
                  for(let a = 0 ; a < this.rootData[i].children.length ; a++){
                    if(data.tree.selectedNode.selectedNode.selectedNode.nodeValue.projectId == this.rootData[i].children[a].id){
                      this.rootData[i].children[a].expand = true;
                      this.rootData[i].children[a].selected = false;
                      this.rootData[i].children[a].children = []
                      if(data.tree.selectedNode.selectedNode.children.length !== 0){
                        data.tree.selectedNode.selectedNode.children.map((item1)=>{
                          this.rootData[i].children[a].children.push({
                            color: local.getObjectUpdateColor(item1.nodeValue.updated),
                            title: item1.nodeValue.directoryName,
                            id: item1.nodeValue.id,
                            resType: item1.nodeValue.resType,
                            deviceType: item1.nodeValue.deviceType,
                            selected: item1.nodeValue.id == item[2] ? true :false,
                            expand: false,
                            children: item1.nodeValue.hasSubItems == true ? [{}] : []
                          });
                        })
                      }
                      for(let w = 0 ; w < this.rootData[i].children[a].children.length ; w++){
                        if(data.tree.selectedNode.selectedNode.selectedNode.selectedNode.nodeValue.directoryId == this.rootData[i].children[a].children[w].id){
                          this.rootData[i].children[a].children[w].expand = true;
                          this.rootData[i].children[a].children[w].selected = false;
                          this.rootData[i].children[a].children[w].children = []
                          if(data.tree.selectedNode.selectedNode.selectedNode.children.length !== 0){
                            data.tree.selectedNode.selectedNode.selectedNode.children.map((item1)=>{
                              this.rootData[i].children[a].children[w].children.push({
                                color: local.getObjectUpdateColor(item1.nodeValue.updated),
                                title: item1.nodeValue.pntName,
                                id: item1.nodeValue.id,
                                resType: item1.nodeValue.resType,
                                // deviceType: item1.nodeValue.deviceType,
                                selected: item1.nodeValue.id == item[2] ? true :false,
                                expand: false,
                                // children: item1.nodeValue.hasSubItems == true ? [{}] : []
                              });
                            })
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              this.$Message.error(data.msg);
            }
          });
        }
      }
    },
    position(){
    },
    getObjectUpdateColor(updated){
        let dtNow = new Date();
        updated = new Date( updated );
       if( updated.getFullYear() < dtNow.getFullYear() ){
          //绯色
          return '#7a1723';
        }
        if( updated.getMonth() < dtNow.getMonth() ){
          //丹色
          return '#b64533';          
        }
        if( (updated.getDate() + 7 )< dtNow.getDate() ){
          //铅丹色
          return '#f3715c';
        }        
        
        if( (updated.getDate() + 3 )< dtNow.getDate() ){
          //朱色
          return 'yellow';
        }        
        if( (updated.getDate())< dtNow.getDate() ){        
          return 'yellow';
        }
        if( (updated.getHours() + 12 )< dtNow.getHours() ){
          //白绿
          return '#cde6c7';
        }      
        
        if( (updated.getHours() + 6 )< dtNow.getHours() ){
          //浅绿
          return '#84bf96';
        }
           
        if( (updated.getHours() )< dtNow.getHours() ){
          //练色
          return '#84bf96';
        }   
        if( (updated.getMinutes() + 30 )< dtNow.getMinutes() ){
          //绿青
          return '#40835e';
        };
        
        if( (updated.getMinutes() + 5 )< dtNow.getMinutes() ){
          //深绿
          return '#005831';
        };
        return 'green';

    },
    //树形控件数据
    loadRootClientData() {
      let local =this;
      this.rootData = []
      api("GET", "clientRoot", {}).then(res => {
        let data = res.data;
        if (data.code === 0) {
          for (let i = 0; i < data.clients.length; i++) {
            this.rootData.push({
              color: "#a1a3a6",//银色
              title: data.clients[i].cliName,
              id: data.clients[i].id,
              resType: 0,
              selected: false,
              expand: false,
              children: data.clients[i].hasStations == true ? [{}] : []
            });
          }
        } else {
          this.handleLogOut().then(() => {
            this.$router.push({
              name: "login"
            });
          });
          this.$Message.error(data.msg);
        }
      });
    },
     renderContent (h, { root, node, data }) {
                return h('span', {
                    style: {
                        display: 'inline-block',
                        width: '100%',
                        cursor: 'pointer',
                    },
                    on:{
                      click: ()=>{
                        this.selectedNodeId = node.nodeKey;
                        this.onExchangChange( data );
                      },
                      mouseover: ()=>{
                        this.overNodeId = node.nodeKey;
                      }
                    }
                }, [
                    h('span', [
                        h('Icon', {
                            props: {
                                type: 'md-square'
                            },
                            style: {
                                marginRight: '8px',
                                color: data.color

                            }
                        }),
                        h('span',{
                            style: {                                
                                color: node.nodeKey==this.selectedNodeId?"blue":"grey",
                                backgroundColor:node.nodeKey==this.overNodeId?"#d1c7b7":"",
                            }
                          },
                          data.title)
                    ])
                ]);
            }

  //end methods
  },
  mounted() {
    // let self = this;
    // global.$on("position", function(val) {
    //   //监听first组件的txt事件
    //   self.path = val;
    // });
    this.loadRootClientData();
  },
  watch: {
    path: {
      handler(newValue, oldValue) {
        this.locateItem(newValue);
      },
      deep: true
    }
  },
  computed: {}
};
</script>
<style scoped>
/* .tree {
  margin: 20px;
} */
</style>